export enum GetEnumTypeForPaymentTypeInformation {
  StraightLineByDays = 1,
  Salary = 2,
  Dividend = 3,
  Percent = 4,
  Profit = 5,
  Scholarship = 6,
  Other = 7,
  PaymentOfService = 8,
  Royalties = 9,
  ReturnedPension = 10,
  PaymentTaxableBySocialTax = 11,
  PaymentOfLeasingService = 12,
  PaymentToOwnerOfTaxableIncomeOfFellowship = 13,
  OilOrGasOperations = 14,
  InternationalShipping = 15,
}

export enum GetEnumTypeForPaymentIncomeReceiversInformation {
  NaturalPersonsEmployed = 1,
  NonTaxpayerPerformingServices20Percent = 2,
  NaturePersonsIncomeTaxedByBuyingPerson = 3,
  NonTaxpayerPerformingServices5Percent = 4,
  NaturalPersonsInPossessionOfHotelShares = 5,
  OtherNaturalPersons = 6,
  LegalEntitiesRegisteredInOffshoreCountries = 7,
  NaturalPersonsRegisteredInOffshoreCountries = 8,
  NonResidentLegalEntitiesWithoutPE = 9,
  NonResidentNaturalPersonsWithoutPE = 10,
  IndividualNonResidentSubContractorOilGas = 11,
  PaymentsFromEntrepreneurIndividualIntlTransportComm = 12,
  LegalEntityNonResidentSubContractorOilGas = 13,
  PaymentsFromLegalEntityIntlTransportComm = 14,
}
